<template>
  <div class="contain" ref="contain">
    <div class="wow animate__zoomInRight"
      style="font-size:max(7vw,48px);text-transform: uppercase;color: hsla(0,0%,100%,.3);font-weight: 600;letter-spacing:1px">
      about</div>
    <div class="wow animate__zoomInRight" data-wow-delay="0.3s"
      style="font-size:max(5vw,24px);text-transform: uppercase;color: #fff;font-weight: 600;letter-spacing:1px">about</div>
  </div>

  <div class="container1">
    <h1 class="wow animate__fadeInUp">About MyD</h1>
    <div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.1s">
        <p>MYD is rich in the dual meanings of My Digital Marketing and Make Your Dreams. It is not only a clever fusion
          of the brand name, but also a deep condensation of our corporate culture and development philosophy.
          <br />My Digital Marketing represents our focus and deep cultivation in the field of digital marketing. We
          combine cutting-edge performance technologies such as social media marketing, SEO, PPC, content marketing, and
          email marketing with first-class creative production to customize marketing plans for customers, help them
          stand out from the competition, shape their brand image, and maximize their commercial value.
          <br />Make Your Dreams carries our beautiful expectations for every employee and every partner. At MYD,
          whether you are a passionate young person with entrepreneurial dreams or an industry elite seeking
          breakthroughs, we will fully support you, provide broad development space and abundant resources, and work
          hand in hand with you to turn your dreams into reality.
        </p>
      </div>
      <div class="wow animate__fadeInUp" data-wow-delay="0.2s"><img src="@/assets/about-icon.png" width="100%" /></div>
    </div>

    <div>
      <div>
        <h1 class="wow animate__fadeInUp">Values</h1>
        <p class="wow animate__fadeInUp" data-wow-delay="0.1s"><strong>1.Digital innovation:</strong> keep a close eye
          on digital technology, apply cutting-edge technology, innovate thinking, provide forward-looking solutions,
          and lead industry change.<br /><strong>2.Dream achievement:</strong> believe in infinite possibilities,
          respect dreams, create an environment, encourage excellence, achieve others and
          yourself.<br /><strong>3.Collaboration and win-win:</strong> attach importance to teamwork, departmental
          collaboration, long-term mutual benefit with partners, integrate resources, overcome difficulties together,
          and develop together.</p>
        <h1 class="wow animate__fadeInUp" data-wow-delay="0.2s">Mission</h1>
        <p class="wow animate__fadeInUp" data-wow-delay="0.3s">MYD's mission is to tap into digital potential with its
          deep technical background and innovative capabilities, customize marketing and technical services for
          customers, and enhance their brand and business competitiveness. At the same time, it builds a dream platform
          to provide development space and resources for employees and partners, stimulate their potential, work
          together to pursue their dreams, promote the digital economy, and create social value.</p>
      </div>
      <div class="wow animate__fadeInUp"><img src="@/assets/about-icon1.png" width="100%" /></div>
    </div>
  </div>

  <div class="container2" ref="container2">
    <h1 class="wow animate__fadeInUp" data-wow-delay="0.1s">Engage with our Way of Work & <br />Explore our Services in
      Detail</h1>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';


const contain = ref(null);
const container2 = ref(null);
let observer = null;

const handleIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('clip-path-effect');
    } else {
      entry.target.classList.remove('clip-path-effect');
    }
  });
};
onMounted(() => {
  observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.05 // 当元素 10% 进入视口时触发
  });
  if (contain.value) {
    observer.observe(contain.value);
  }
  if (container2.value) {
    observer.observe(container2.value);
  }
});

onUnmounted(() => {
  if (observer && contain.value) {
    observer.unobserve(contain.value);
  }
  if (observer && container2.value) {
    observer.unobserve(container2.value);
  }
});

</script>

<style lang="less" scoped>
.contain {
  background-image: url('../assets/about-bg.png') !important;
  background-repeat: no-repeat;
  background-position: center right;
  background-color: #fff;
  background-size: cover;
  min-height: 80vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 70%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 70%);
  }

  >div:nth-child(1) {
    position: absolute;
    top: 63%;
    right: 10%;
  }

  >div:nth-child(2) {
    position: absolute;
    top: 69%;
    right: 14%;
  }
}

.container1 {
  margin-bottom: 10%;

  h1 {
    text-transform: uppercase;
  }

  >div:nth-child(2) {
    display: flex;
    width: 75%;
    margin: auto;
    gap: 3%;
    text-align: left;
    flex-wrap: wrap;
    margin-top: 5%;

    >div {
      flex: 2;
      min-width: 300px;
      font-weight: 300;
      line-height: 1.7;
      color: #1a2e42;
      font-family: Space Grotesk, sans-serif !important;
    }

    >div:nth-child(2) {
      flex: 3;
    }
  }

  >div:nth-child(3) {
    display: flex;
    width: 75%;
    margin: auto;
    gap: 5%;
    text-align: left;
    flex-wrap: wrap;
    margin: 5% auto;

    >div {
      flex: 2;
      min-width: 300px;
      font-weight: 300;
      line-height: 1.7;
      color: #1a2e42;
      font-family: Space Grotesk, sans-serif !important;
    }

    p {
      font-weight: 400;
    }
  }
}

.container2 {
  background-image: url('../assets/about-icon2.png') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
  display: flex;
  justify-content: center;
  align-items: center;

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
  }

  >h1 {
    font-weight: 500;
    font-size: max(2vw, 18px);
    line-height: 1.5;
  }
}

@media all and (max-width:600px) {
  .contain {
    min-height: 0px;
    aspect-ratio: 5/6 !important;
    >div:nth-child(1) {
      position: absolute;
      top: 40%;
      right: 10%;
    }

    >div:nth-child(2) {
      position: absolute;
      top: 45%;
      right: 15%;
    }
  }

  .container {
    flex-direction: column;

    >div {
      width: 100%;
      text-align: center;
    }
  }

  .container1 {

    >div:nth-child(2) {
      width: 90%;
    }

    >div:nth-child(3) {
      width: 90%;
    }
  }

  .container2 {
    min-height: 0px;
    aspect-ratio: 5/7 !important;

    &.clip-path-effect {
      -webkit-clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
      clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
    }
  }
}
</style>
